import "./crucible.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Crucible() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731593129/crucible1_ulug4v.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731593129/crucible2_idy2nj.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731593129/crucible4_sg5hv0.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731593128/crucible3_g6fomz.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (

    <div className='main_wrapper'>
        <Helmet>
        <title>Crucible Pot || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="Silicon carbide (SiC) crucibles are containers used in metalworking, specifically designed for melting and holding high-temperature materials, such as metals and alloys. Known for their high thermal conductivity, resistance to chemical corrosion, and durability under extreme conditions, these crucibles are ideal for applications in foundries, metal casting, glassmaking, and laboratories"/>
        <meta name="keywords" content="crucible pot , melting pot , graphite crucible , silicon carbide crucible, Lagos Nigeria" />
	    </Helmet>
        <h3>Silicon Carbide Crucible</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Key Characteristics of Our  Crucible:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Thermal Conductivity
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>High Temperature Resistance
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Excellent Chemical Resistance
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Abrasion and Wear Resistance
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
        Silicon carbide (SiC) crucibles are containers used in metalworking, specifically designed for melting and holding high-temperature materials, such as metals and alloys. Known for their high thermal conductivity, resistance to chemical corrosion, and durability under extreme conditions, these crucibles are ideal for applications in foundries, metal casting, glassmaking, and laboratories.
        </div>
    </div>
  )
}
